import { render, staticRenderFns } from "./navigation-market-selector.vue?vue&type=template&id=ad5590d6&"
import script from "./navigation-market-selector.vue?vue&type=script&lang=js&"
export * from "./navigation-market-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports